export default class CheckboxUnchecked {
  constructor(node) {
    this.element = node;
    this.checkbox = this.element.querySelector(".js-checkbox");
    this.hiddenInput = this.element.querySelector(".js-hidden-input");

    this.initialize();
  }

  initialize() {
    this.checkbox.addEventListener("change", () => {
      this.hiddenInput.value = this.checkbox.checked;
    });
  }
}
